module.exports = __webpack_public_path__ + "static/media/brickmagic.9a49ed9b.jpg";